import {api} from '../../api';
import {createMutation} from '../../lib';

const {postFiltersSets} = api.filtersSets;

export const usePostFiltersSets = createMutation((params: Parameters<typeof postFiltersSets>) =>
  postFiltersSets(...params),
);
